import { useState } from 'react';

import { OfferCard } from '@/components/Shared/ui';
import { type TAutoCredLeasingResponse } from '@/types/newOrder';

import { LeasingDetails } from '../../ui';

type TLeasingDeclinedItemProps = {
  leasingOffer: TAutoCredLeasingResponse;
};

const LeasingDeclinedItem = ({ leasingOffer }: TLeasingDeclinedItemProps) => {
  const [isLeasingDetailsModalOpen, setIsLeasingDetailsModalOpen] =
    useState(false);

  return (
    <>
      <OfferCard
        className="bank-item"
        status="error"
        statusText={leasingOffer.status.name}
        isLeasing
      >
        <OfferCard.Header
          title={leasingOffer.leasingCompany.name}
          icon={leasingOffer.leasingCompany.icon}
          status="error"
          descriptionAction={
            leasingOffer.comment
              ? {
                  onClick: () => setIsLeasingDetailsModalOpen(true),
                  text: <span className="offer-body__hidden">Описание</span>
                }
              : undefined
          }
        />
      </OfferCard>

      <LeasingDetails
        isModalOpen={isLeasingDetailsModalOpen}
        leasingOffer={leasingOffer}
        onClose={() => setIsLeasingDetailsModalOpen(false)}
      />
    </>
  );
};

export default LeasingDeclinedItem;
